export type RequirementType = 'Event Space' | 'Hotel Room Block' | 'Private Dining' | 'Office / Coworking';

export const EVenueType = {
    HOTEL: 'Hotel',
    RESTAURANT: 'Restaurant',
    MUSEUM: 'Museum',
    BAR: 'Bar',
    BREWERY: 'Brewery',
    WINERY: 'Winery',
    UNIQUE_VENUE: 'Unique Venue',
    ACTIVITY: 'Activity',
    CONFERENCE_CENTER: 'Conference Center',
    CORPORATE_OFFICE: 'Corporate Office',
    EVENT_VENUE: 'Event Venue',
    THEATER: 'Theater',
    COWORKING_SPACE: 'Coworking Space',
} as const;

export type EVenueType = (typeof EVenueType)[keyof typeof EVenueType];

export const venueTypes: Record<RequirementType, string[]> = {
    'Event Space': [
        'hotel',
        'activity',
        'conference center',
        'bar',
        'brewery',
        'winery',
        'museum',
        'theater',
        'event venue',
        'unique venue',
    ],
    'Hotel Room Block': ['hotel'],
    'Private Dining': ['restaurant', 'bar', 'winery', 'brewery'],
    'Office / Coworking': [
        // 'professional workspace',
        'coworking space',
        'corporate office',
        // 'bookable office'
    ],
};

// TODO: Will need to map all ids for venue types
export const VENUE_ID_CORPORATE_OFFICE = 10;
